import { render } from "./OThemePresetPicker.vue?vue&type=template&id=b4b3f428&scoped=true"
import script from "./OThemePresetPicker.vue?vue&type=script&lang=js"
export * from "./OThemePresetPicker.vue?vue&type=script&lang=js"

import "./OThemePresetPicker.vue?vue&type=style&index=0&id=b4b3f428&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b3f428"]])

export default __exports__